export const phoneRegExp = /^\+[0-9]+$/
